import {createStandardAction} from 'typesafe-actions'
import {SoundMarker} from '../../model/SoundMarker'
import {IndexedSoundMarker} from '../../model/IndexedSoundMarker'

export const soundMarkerAdded = createStandardAction('marker/soundMarkerAdded')<{ soundMarker: SoundMarker }>()
export const soundMarkerDeleted = createStandardAction('marker/soundMarkerDeleted')<{ soundMarker: IndexedSoundMarker }>()
export const allSoundMarkersDeleted = createStandardAction('marker/allSoundMarkersDeleted')<void>()
export const toggleSoundMarker = createStandardAction('marker/toggleSoundMarker')<{ rating?: number }>()
export const toggleOrPushUpSoundMarker = createStandardAction('marker/toggleOrPushUpSoundMarker')<void>()
export const soundMarkerUpdated = createStandardAction('marker/soundMarkerUpdated')<{ soundMarker: IndexedSoundMarker }>()